import { gql } from '@apollo/client'
import { gpsrPartyInfo } from '../fragments/gpsr-party'

export const GET_GPSR_CATEGORY_LIST = gql`
  query GetGpsrCategoryList {
    gpsrCategoryList {
      id
      category
    }
  }
`

export const GET_GPSR_BRANDS_BY_CATEGORY = gql`
  query GetGpsrBrandsByCategory($category_id: Int!) {
    gpsrBrandsByCategory(category_id: $category_id) {
      id
      brand
      category_id
      source
      has_party
    }
  }
`

export const GET_GPSR_PARTIES_BY_BRAND = gql`
  query GetGpsrPartiesByBrand($brand_id: Int!, $source: String!) {
    gpsrPartiesByBrand(brand_id: $brand_id, source: $source) {
      ...gpsrPartyInfo
    }
  }
  ${gpsrPartyInfo}
`

export const UPDATE_GPSR_PARTY_BY_BRAND = gql`
  mutation UpdateGpsrPartyByBrand(
    $brand_id: Int!
    $source: String!
    $data: GpsrPartyUpdateInput!
  ) {
    updateGpsrPartyByBrand(brand_id: $brand_id, source: $source, data: $data) {
      ...gpsrPartyInfo
      brand_id
      source
    }
  }
  ${gpsrPartyInfo}
`

export const INSERT_BRAND = gql`
  mutation InsertBrand($brand: String!, $categoryId: Int!, $svidMerk: Int) {
    insertBrand(brand: $brand, category_id: $categoryId, svid_merk: $svidMerk) {
      id
      brand
      category_id
      source
    }
  }
`

export const INSERT_PARTY = gql`
  mutation InsertParty(
    $brand: String!
    $svid_merk: Int!
    $category_id: Int!
    $carfileId: Int
    $gpsr_message_off: Boolean
    $data: GpsrPartyUpdateInput
  ) {
    insertGpsrPartyBrand(
      brand: $brand
      svid_merk: $svid_merk
      category_id: $category_id
      carfileId: $carfileId
      gpsr_message_off: $gpsr_message_off
      data: $data
    ) {
      ...gpsrPartyInfo
    }
  }
  ${gpsrPartyInfo}
`
